var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8321 18.1088C8.53884 18.1088 5.80371 15.3899 5.80371 11.9912C5.80371 8.64913 8.53884 5.93018 11.8321 5.93018C15.1255 5.93018 17.8606 8.64913 17.8606 12.0478C17.8606 15.3899 15.1255 18.1088 11.8321 18.1088ZM11.8321 8.19597C9.76685 8.19597 8.03646 9.89532 8.03646 12.0478C8.03646 14.1437 9.71103 15.8997 11.8321 15.8997C13.8974 15.8997 15.6278 14.2003 15.6278 12.0478C15.6278 9.89532 13.8974 8.19597 11.8321 8.19597Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7956 23.9998H7.86933C3.57128 23.9998 0.0546875 20.4312 0.0546875 16.0696V7.96935C0.0546875 3.60769 3.57128 0.0390625 7.86933 0.0390625H15.7956C20.0937 0.0390625 23.6102 3.60769 23.6102 7.96935V16.0129C23.6102 20.4312 20.1495 23.9998 15.7956 23.9998ZM7.86933 2.30486C4.79929 2.30486 2.28744 4.85388 2.28744 7.96935V16.0129C2.28744 19.1284 4.79929 21.6774 7.86933 21.6774H15.7956C18.8656 21.6774 21.3775 19.1284 21.3775 16.0129V7.96935C21.3775 4.85388 18.8656 2.30486 15.7956 2.30486H7.86933Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2fb29beb27a07ccfcc5ac7de6da9953e.svg";
export { ForwardRef as ReactComponent };